import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ff9348e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-info" }

import { withDefaults, ref, Ref } from 'vue'
import {
  MalfunctionRepairDeviceItem,
  MalfunctionRepairDeviceListRenderItem,
} from '@/types/malfunction-repair'
import { MalfunctionRepairSelectedDevicesStorage } from '@/storage/malfunction-repair'
import FaultDeviceList from './fault-device-list.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-form-change-device',
  props: {
    eq_type: { default: 0 },
    selectedList: { default: () => [] }
  },
  emits: ['confirm'],
  setup(__props: any, { emit: emits }) {

const props = __props as { eq_type: 0 | 1 | 2, selectedList: MalfunctionRepairDeviceListRenderItem[] };



const queryDataDeviceSnMap: Ref<Record<string, boolean>> = ref({})
const selectedDevices: Ref<MalfunctionRepairDeviceItem[]> = ref([])
const scanDevice: Ref<null | MalfunctionRepairDeviceItem> = ref(null)
function getSelectedDevices(list: MalfunctionRepairDeviceItem[]) {
  selectedDevices.value = list
}
function deviceSnMapChange(data: Record<string, boolean>) {
  queryDataDeviceSnMap.value = data
}
function confirmSelect() {
  emits('confirm', selectedDevices.value)
  // 直接在缓存保存
  MalfunctionRepairSelectedDevicesStorage.set(selectedDevices.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FaultDeviceList, {
      eq_type: props.eq_type,
      onChange: getSelectedDevices,
      onDeviceSnMapChange: deviceSnMapChange,
      scanDevice: scanDevice.value,
      selectedList: __props.selectedList
    }, null, 8, ["eq_type", "scanDevice", "selectedList"]),
    _createVNode(CommonFooterNextButton, {
      title: "确定",
      disabled: selectedDevices.value.length === 0,
      style: { backgroundColor: '#F6F7F8' },
      onClick: confirmSelect
    }, null, 8, ["disabled"])
  ]))
}
}

})